import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class ExcelOrderImport_ds_get_serialnumbers_by_lots_licenseplates_Service {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { lotLookupcodes?: string[], licenseplateLookupcodes?: string[], packagingNames?: string[], fullTextSearch?: string, lotId?: number, licenseplateId?: number, packagingId?: number, lookupCodes?: string[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/ExcelOrderImport/datasources/ds_get_serialnumbers_by_lots_licenseplates_/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { lotLookupcodes?: string[], licenseplateLookupcodes?: string[], packagingNames?: string[], fullTextSearch?: string, lotId?: number, licenseplateId?: number, packagingId?: number, lookupCodes?: string[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/ExcelOrderImport/datasources/ds_get_serialnumbers_by_lots_licenseplates_/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { lotLookupcodes?: string[], licenseplateLookupcodes?: string[], packagingNames?: string[], fullTextSearch?: string, lotId?: number, licenseplateId?: number, packagingId?: number, lookupCodes?: string[], $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/ExcelOrderImport/datasources/ds_get_serialnumbers_by_lots_licenseplates_/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      lotLookupcodes?: string[], licenseplateLookupcodes?: string[], packagingNames?: string[], fullTextSearch?: string, lotId?: number, licenseplateId?: number, packagingId?: number, lookupCodes?: string[]    }) {
      return false;
    }
}
